import { gql } from '@edreamsodigeo/frontend-api-client';

const SEGMENT_FRAGMENT = gql`
  fragment Segment on Segment {
    id
    carrier {
      id
      name
    }
    sections {
      id
      carrier {
        id
        name
      }
      departure {
        cityIata
        iata
      }
      destination {
        cityIata
        iata
      }
    }
  }
`;

const PRODUCT_INFO_FRAGMENT = gql`
  ${SEGMENT_FRAGMENT}
  fragment ProductInfo on Itinerary {
    tripType
    legs {
      segments {
        ...Segment
      }
    }
  }
`;

export const GET_SHOPPING_BUNDLE = gql`
  ${PRODUCT_INFO_FRAGMENT}
  query GetShoppingBundleCabinBags($request: ShoppingBundleRequest) {
    getShoppingBundle(request: $request) {
      products {
        __typename
        id {
          id
          type
        }
        ... on ItineraryProduct {
          productInfo {
            ...ProductInfo
          }
        }
        ... on AncillariesProduct {
          __typename
          id {
            id
            type
          }
          productInfo {
            cabinBagsSelections {
              segment
              section
              type

              priceBreakdown {
                primeFee {
                  amount
                  currency
                }
                fee {
                  amount
                  currency
                }
              }
              prices {
                type
                price {
                  amount {
                    amount
                    currency
                  }
                  breakdown {
                    items {
                      concept
                      price {
                        amount {
                          amount
                          currency
                        }
                        breakdown {
                          items {
                            concept
                            price {
                              amount {
                                amount
                                currency
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      travellers {
        numPassenger
        personalInfo {
          ageType
        }
      }
    }
  }
`;
